import * as React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions,
    Typography,
    Box,
    Button,
    styled
} from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import { context } from './context';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        maxWidth: '500px',
    },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    '& .MuiSvgIcon-root': {
        fontSize: '64px',
        color: theme.palette.primary.main,
        animation: 'pulse 2s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%, 100%': {
            opacity: 1,
            transform: 'scale(1)',
        },
        '50%': {
            opacity: 0.8,
            transform: 'scale(1.05)',
        },
    },
}));

export const ServerMaintenanceDialog = () => {
    const { serverMaintenance, setServerMaintenance } = React.useContext(context);

    const handleRetry = () => {
        setServerMaintenance(false);
        window.location.reload();
    };

    return (
        <StyledDialog
            open={serverMaintenance}
            disableEscapeKeyDown
            aria-labelledby="maintenance-dialog-title"
        >
            <DialogTitle 
                id="maintenance-dialog-title" 
                sx={{ 
                    textAlign: 'center', 
                    pt: 3,
                    fontSize: '1.5rem',
                    fontWeight: 600 
                }}
            >
                服务器维护中
            </DialogTitle>
            <DialogContent>
                <IconWrapper>
                    <BuildIcon />
                </IconWrapper>
                <Typography 
                    variant="body1" 
                    sx={{ 
                        textAlign: 'center',
                        color: 'text.secondary',
                        mb: 2,
                        lineHeight: 1.8
                    }}
                >
                    抱歉，服务器正在进行维护升级
                </Typography>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        textAlign: 'center',
                        color: 'text.secondary',
                        lineHeight: 1.8
                    }}
                >
                    我们正在努力提供更好的服务，请稍后再试
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
                <Button 
                    variant="contained" 
                    onClick={handleRetry}
                    size="large"
                    sx={{
                        minWidth: '120px',
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                    }}
                >
                    重新连接
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};
